import { Box } from '@mui/material';

import routes from '@/assets/constants/routes-no.ts';
import Page from '@/components/Page/index.ts';
import StaticPageLayout from '@/components/StaticPageLayout/index.ts';

export default function Terms() {
  return (
    <Page title="April-trekning vilkår">
      <StaticPageLayout
        title="Vilkår for Scooprs April-trekning 2024"
        breadcrumbsItems={[
          {
            text: 'Hjem',
            url: '/',
          },
          {
            text: 'April-trekning 2024',
            url: routes.APRIL_2024_COMPETITION,
          },
          {
            text: 'Vilkår for Scooprs April-trekning 2024',
            url: null,
          },
        ]}
        subtitle="Dato for siste versjon: 03.04.2024"
      >
        <Box
          sx={(theme) => ({
            '& h2': {
              marginBottom: theme.spacing(2),
              marginTop: theme.spacing(6),
            },
            '& h3': {
              marginBottom: theme.spacing(1),
              marginTop: theme.spacing(3),
            },
          })}
        >
          <p>
            I April 2024 avholder Scoopr Refinansiering AS og Scoopr AS <b>(«Scoopr»)</b> en
            trekning <b>(«April-trekningen»)</b>, der deltakere har mulighet til å vinne innfrielse
            av rentebærende kredittkortgjeld. Disse vilkårene gjelder for deltakelse i
            April-trekningen.
          </p>
          <h3>1.1 – Krav for deltakelse</h3>
          <p>
            April-trekningen er tilgjengelig for personer over 18 år, som har tilgang til BankID og
            som er bosatt i Norge. Deltakeren må søke om lavere rente via Scoopr og ha rentebærende
            kredittkortgjeld over 1.000 kroner.
          </p>
          <p>
            Deltakere melder seg på April-trekningen ved å trykke{' '}
            <b>«Søk om lavere rente og delta»</b>, godkjenne disse vilkårene, gi samtykke til at
            Scoopr henter ut informasjon fra Gjeldsregisteret samt søker om refinansiering.
          </p>
          <p>
            Det koster ingenting å delta i April-trekningen, men det er et krav om at deltakeren har
            en <b>«Min Scoopr»</b>- bruker/Scoopr medlem og søker om lavere rente via Scoopr.
            Vilkårene for Min Scoopr finnes{' '}
            <a href="https://scoopr.no/brukervilkar-min-scoopr" target="_blank" rel="noreferrer">
              her
            </a>
            . Deltakeren kan når som helst avslutte sin brukerkonto etter at April-trekningen er
            avsluttet.
          </p>
          <p>
            Ansatte i Scoopr og deres ektefeller, samboere, foreldre, søsken eller barn kan ikke
            delta i April-trekningen. Deltakere som ikke oppfyller kravene, kan bli nektet lodd
            og/eller premie.
          </p>
          <h3>1.2 – Om premien</h3>
          <p>
            Premien som utloddes til vinneren i April-trekningen består av innfrielse av deltakerens
            rentebærende kredittkortgjeld inntil <b>kr 100.000</b>. Premien er likevel aldri større
            enn vinnerens rentebærende kredittkortgjeld på registreringstidspunktet.
          </p>
          <p>
            Beløpet innfris direkte hos banken hvor gjelden er registrert. Innfrielse skjer normalt
            i løpet av en uke etter trekning. Dersom det er registrert kredittkortgjeld hos flere
            banker velger Scoopr hvilken bank gjelden innfris hos. Det er ikke anledning til å få
            beløpet utbetalt i kontanter, eller i form av andre ytelser.
          </p>
          <p>
            Dersom deltaker velger å refinansiere sin kredittgjeld hos Scoopr innen trekningen, vil
            premien kunne benyttes til å nedbetale på det nye lånet.
          </p>
          <h3>1.3 – Vilkår for mottak av premie</h3>
          <p>
            Vinneren kontaktes på telefon og e-post. Vinneren må straks etter å ha blitt kontaktet
            oppgi og bekrefte betalingsopplysninger slik at den aktuelle gjelden kan innfris. Dersom
            dette ikke er gjort innen 5 dager, vil retten til premie kunne bortfalle.
          </p>
          <p>
            Vinnere er selv ansvarlig for å rapportere og håndtere eventuell gevinst til
            skattemyndighetene, samt overholdelse av andre lovpålagte krav i forbindelse med
            gevinsten.
          </p>
          <h3>1.4 – Varighet og trekning</h3>
          <p>
            Deltakere som søker om lavere rente i perioden fra 1. April 2024 til 30. April 2024{' '}
            <b>(«Trekningsperioden»)</b> er med i April-trekningen, og det trekkes vinner den 2. mai
            2024.
          </p>
          <p>
            Vinneren trekkes tilfeldig ved at alle deltakere får tildelt et deltakernummer.
            Trekningen gjøres gjennom en <b>«random number generator service»</b>.
          </p>
          <h3>1.5 – Ansvarlig arrangør og tredjeparter</h3>
          <p>Det er Scoopr som er arrangør av April-trekningen.</p>{' '}
          <p>
            April-trekningen støttes eller sponses ikke av noen tredjepart. Det opplyses særskilt om
            at April-trekningen verken støttes eller sponses av Meta, TikTok eller Google, selv om
            markedsføring skulle foregå gjennom disse kanalene. Deltakere kan ikke rette noen krav
            mot slike tredjeparter i forbindelse med konkurransen.{' '}
          </p>
          <h3>1.6 – Personopplysninger</h3>
          <p>
            I forbindelse med deltakelse vil Scoopr behandle personopplysninger. Personopplysningene
            benyttes til å registrere <b>«Min Scoopr»</b>
            -bruker, kontrollere overholdelse av vilkår og utnevne og kontakte vinner.
          </p>
          <p>
            Scoopr behandler også opplysninger fra Gjeldsregisteret. Samtykket kan trekkes tilbake
            når som helst pa{' '}
            <a href="https://www.gjeldsregisteret.com/" target="_blank" rel="noreferrer">
              www.gjeldsregisteret.com
            </a>
            .
          </p>
          <p>
            I løpet av Treknings-perioden kan Scoopr sende informasjon på e-post og SMS for å minne
            om April-trekningen og gi informasjon om trekning og vinnere. Vinnere vil aldri bli
            annonsert med fullt navn, med mindre vinneren har samtykket til dette.
          </p>
          <p>
            Dersom deltakeren har takket ja til å motta markedsføring fra Scoopr, vil det også
            sendes markedsføring til vedkommende, også i etterkant av kalenderperioden.
          </p>
          <p>
            Opplysningene om deltakere lagres i perioden April-trekningen avholdes og i en viss
            periode etterpå for å kunne påvise at Scoopr har overholdt lovpålagte krav.
            Opplysningene registrert i Min Scoopr oppbevares frem til brukeren sletter sin profil.
          </p>
          <p>
            Opplysningene kan bli delt med andre selskaper i Scoopr-konsernet for formålene
            beskrevet over. Se mer informasjon i Scooprs personvernerklæring{' '}
            <a href="https://scoopr.no/personvernerklaering/" target="_blank" rel="noreferrer">
              her
            </a>
            .
          </p>
          <h3>1.7 – Avbryte</h3>
          <p>
            Dersom uforutsette hendelser skulle oppstå, som Scoopr ikke med rimelighet kunne forutse
            ved igangsetting av April-trekningen, forbeholder Scoopr seg retten til å avbryte
            konkurransen med fremtidig virkning. Scoopr vil utlodde premier til vinnere som allerede
            er trukket og så langt mulig varsle deltakere og gi deltakere mulighet for
            avregistrering og avslutning av Min Scoopr-brukeren.
          </p>
          <h3>1.8 – Henvendelser</h3>
          <p>
            Dersom deltakeren har spørsmål om disse vilkårene eller andre forhold kan Scoopr
            Refinansiering AS, med adresse Karenslyst Allé 2, 0278 Oslo, kontaktes på telefon 488 46
            665 eller <a href="mailto:post@scoopr.no">post@scoopr.no</a>.
          </p>
          <br />
          <h4>Scoopr AS</h4>
          <h4>Scoopr Refinansiering AS</h4>
          <p>
            <a href="mailto:post@scoopr.no">post@scoopr.no</a>
          </p>
          <p>Karenslyst Allé 2</p>
          <p>0278 Oslo</p>
        </Box>
      </StaticPageLayout>
    </Page>
  );
}
